import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { events } from "@/mocks/events";
import { formatDate } from "@/utils/content";

export default function LatestUpdates() {
  const updates = events
    .flatMap((event) =>
      event.timeline.map((item) => ({
        date: item.date,
        title: item.title,
        text: item.text,
        eventId: event.id,
        eventTitle: event.title,
        category: event.category,
      })),
    )
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, 6);

  return (
    <section className="w-full bg-background-100/50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <SectionHeading
            eyebrow="Latest"
            title="最新证据更新"
            description="按整理时间倒序，每一条都对应到具体事件的时间线节点。"
          />
          <Link
            to="/events"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap self-start md:self-auto"
          >
            浏览全部更新
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <ul className="mt-10 divide-y divide-background-200/70 border-t border-b border-background-200/70">
          {updates.map((update) => (
            <li key={`${update.eventId}-${update.date}-${update.title}`}>
              <Link
                to={`/event/${update.eventId}`}
                className="group grid grid-cols-1 md:grid-cols-[140px_1fr_auto] gap-2 md:gap-6 py-5 cursor-pointer"
              >
                <div className="flex items-center gap-2 text-xs md:text-sm text-foreground-500">
                  <i className="ri-calendar-line text-primary-500" />
                  {formatDate(update.date)}
                </div>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-300 border border-secondary-300/40">
                      {update.category}
                    </span>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
                      {update.eventTitle}
                    </h3>
                  </div>
                  <p className="mt-1.5 text-sm font-medium text-foreground-700">{update.title}</p>
                  <p className="mt-1 text-sm leading-6 text-foreground-500 line-clamp-2">{update.text}</p>
                </div>
                <div className="flex md:items-center justify-end text-foreground-500 group-hover:text-primary-500 transition-colors">
                  <i className="ri-arrow-right-up-line text-lg" />
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}